<script lang="ts" setup>
import { entries } from '@/utils/entries'

interface Props {
  tabs: any
  selectedTab: string
  whenTabSelect: (tab: string) => void
  isDisabled: boolean
}

const props = defineProps<Props>()
</script>

<template>
  <div class="Tabs">
    <a-tag
      v-for="[key, tab] in entries(tabs)"
      class="Tabs__tab"
      :class="{ Tabs__tab_selected: props.selectedTab === key,
       Tabs__tab_disabled: props.isDisabled
      }"
      :key="key"

      @click="() => !props.isDisabled && props.whenTabSelect(key)"
    >
      {{ tab }}
    </a-tag>
  </div>
</template>

<style lang="scss" scoped>
.Tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.Tabs__tab {
  background-color: var(--gray_white);
  border: 1px solid var(--gray_10);
  color: var(--gray_60);
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px;

  &_selected {
    background-color: var(--brand_50);
    border-color: var(--brand_50);
    color: var(--gray_white);
  }

  &_disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
